import './App.css';

import { OidcProvider } from '@axa-fr/react-oidc';
import { FontScaleContextProvider, MessageChannelContextProvider, UIConfigProvider } from '@healthhub/react-ui';
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { PersistGate } from 'redux-persist/integration/react';

import { I18nInitializer } from '@shared/components/I18nInitializer';
import { AUTH_CONFIG } from '@shared/configs/authentication';
import { router } from '@shared/configs/configs/router';
import { GlobalBreadcrumbsContextWrapper, PageTitleContextWrapper, StylesConfigContextWrapper } from '@shared/context';
import { persistor, store } from '@shared/stores';
import { initializeAxiosInterceptor } from '@shared/utils/api/interceptor';
import { MESSAGE_ACTION } from '@shared/utils/bridge';
import { enableConsoleLoggingForAllowedEnvironments } from '@shared/utils/console';

interface ConfigAppProps {
  children?: React.ReactNode;
}

enableConsoleLoggingForAllowedEnvironments();
initializeAxiosInterceptor();

export const ConfigApp = ({ children }: ConfigAppProps) => (
  <UIConfigProvider>
    <OidcProvider {...AUTH_CONFIG}>
      <I18nInitializer>
        <PersistGate loading={null} persistor={persistor}>
          <Provider store={store}>
            <MessageChannelContextProvider messageAction={MESSAGE_ACTION}>
              <FontScaleContextProvider>
                <StylesConfigContextWrapper>
                  <PageTitleContextWrapper>
                    <GlobalBreadcrumbsContextWrapper>{children}</GlobalBreadcrumbsContextWrapper>
                  </PageTitleContextWrapper>
                </StylesConfigContextWrapper>
              </FontScaleContextProvider>
            </MessageChannelContextProvider>
          </Provider>
        </PersistGate>
      </I18nInitializer>
    </OidcProvider>
  </UIConfigProvider>
);

const App = () => (
  <div className="App">
    <Suspense fallback={null}>
      <ConfigApp>
        <RouterProvider router={router} />
      </ConfigApp>
    </Suspense>
  </div>
);

export default App;
